import { render, staticRenderFns } from "./platUpRateRecord.vue?vue&type=template&id=3a0a3b1f&"
import script from "./platUpRateRecord.vue?vue&type=script&lang=js&"
export * from "./platUpRateRecord.vue?vue&type=script&lang=js&"
import style0 from "./platUpRateRecord.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports